



















































import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import Vue from "vue";
import { passwordApi } from "../services/password.api";
import appSnackbarService from "../../../services/appSnackbar.service";

@Component({})
export default class ResetPassword extends Vue {
  password1 = "";
  password2 = "";
  userName = "";
  errorMessage = "";
  valid = false;
  loading = false;

  passwordRule = v => {
    if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(v)) {
      return (
        "A jelszónak legalább 8 karakterből kell állnia, " +
        "es tartalmaznia kell legalább 1 szamot, 1 nagy es 1 kis betut"
      );
    }
  }

  changePassword() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      this.loading = true;
      passwordApi
        .resetPassword(this.userName, this.password2, this.$route.query.token)
        .then(() => {
          this.$router.replace("/login");
          appSnackbarService.success(
            "Sikeres jelszo beallitás! Bejelentkezhet az uj jelszoval!"
          );
        })
        .catch(error => {
          this.errorMessage =
            "Hiba tortent a jelszo beállitásakor. " +
            "Kervenyezzen uj <a href='/passwordReset'>jelszo visszaállitást</a>!";
          this.loading = false;
        });
    }
  }
}
